import {
  RegistrationUser,
  RegistrationUserBody,
  RegistrationUserState,
} from '../interfaces/registration';
import { IHttpResponse } from './BackendService';
import { postAuth } from './AuthHttpService';
import { IDataBundle } from '../interfaces/data-bundle.interface';
import { IDevProfile } from '../interfaces/dev-profile';
import { getUnixTimestamp } from '../helpers/date-helper';
import { postDevProfile } from './HatApiService';
import { AUTH_URL, DEV_PORTAL_APP_ID, DEV_PORTAL_API_URL } from '../app-config';
import { RouterPaths } from '../constants/routes';

export const signupUser = async (
  body: RegistrationUserBody,
): Promise<IHttpResponse<RegistrationUser>> =>
  postAuth<RegistrationUser>(`${DEV_PORTAL_API_URL}/api/v1/signup`, body);

export const postProfile = async (
  profile: RegistrationUserState,
  hatUrl: string,
): Promise<IHttpResponse<IDataBundle<IDevProfile>>> => {
  const devProfile: IDevProfile = {
    personal: {
      firstName: profile.firstName,
      lastName: profile.lastName,
      company: profile.company,
      country: profile.country,
    },
    dateCreated: getUnixTimestamp(),
  };
  return postDevProfile(`${hatUrl}`, devProfile);
};

export const generateSignupUrl = (email: string): string => {
  const redirectUri = window.location.origin + RouterPaths.authenticateHat;

  return `${AUTH_URL}/services/signup?email=${email}&application_id=${DEV_PORTAL_APP_ID}&redirect_uri=${redirectUri}`;
};
